function writeToLocalStorage(key, value) {
  try {
    const valueToStore =
      typeof value === "string" ? value : JSON.stringify(value);
    localStorage.setItem(key, valueToStore);
  } catch (error) {
    console.error(`Error saving to localStorage: ${error}`);
  }
}

function readFromLocalStorage(key) {
  try {
    const item = localStorage.getItem(key);
    if (item) {
      return JSON.parse(item);
    }
    return null;
  } catch (error) {
    console.error(`Error reading from localStorage: ${error}`);
    return localStorage.getItem(key); // Return as a string if JSON parse fails
  }
}

function removeFromLocalStorage(key) {
  try {
    localStorage.removeItem(key);
  } catch (error) {
    console.error(`Error removing from localStorage: ${error}`);
  }
}

export { writeToLocalStorage, readFromLocalStorage, removeFromLocalStorage };
